module.exports = __webpack_public_path__ + "static/img/zhihui-5.8e67436.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zhihui-5.png
// module id = 7U1N
// module chunks = 46